import { render, staticRenderFns } from "./BirdHouse.vue?vue&type=template&id=95fbba8e&scoped=true"
import script from "./BirdHouse.vue?vue&type=script&lang=js"
export * from "./BirdHouse.vue?vue&type=script&lang=js"
import style0 from "./BirdHouse.vue?vue&type=style&index=0&id=95fbba8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fbba8e",
  null
  
)

export default component.exports